export const POPOVER_PANEL_CLASSES = 'rounded-3xl bg-white border border-black/5 shadow-[0_4px_6px_rgba(0,0,0,0.08)]';
